(() => {
  function initialize(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = '1';
    const list = section.querySelector('[data-review-list]');
    const more = section.querySelector('[data-load-more]');
    const status = section.querySelector('[data-review-status]');
    const urls = [1, 2, 3, 4].map(number => section.getAttribute(`data-reviews-url-${number}`));
    let reviews;
    let offset = 0;
    let loading = false;

    const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[char]));
    const initials = name => String(name).trim().split(/\s+/).slice(0, 2).map(part => Array.from(part)[0] || '').join('').toUpperCase();
    const date = value => new Date(`${value}T12:00:00`).toLocaleDateString('en-US', {month:'short', day:'numeric', year:'numeric'});
    function row(review) {
      const rating = Number(review.rating);
      return `<article class="yr2__card"><div class="yr2__person"><div class="yr2__avatar" aria-hidden="true">${escape(initials(review.name))}</div><div><p class="yr2__name">${escape(review.name)}</p><p class="yr2__badge">✓ Customer Review</p></div></div><div class="yr2__content"><div class="yr2__top"><div class="yr2__stars" aria-label="${rating} out of 5 stars">${'★'.repeat(rating)}${'☆'.repeat(5-rating)}</div><time class="yr2__date" datetime="${escape(review.date)}">${escape(date(review.date))}</time></div>${review.title ? `<h3 class="yr2__title">${escape(review.title)}</h3>` : ''}${review.review ? `<p class="yr2__copy">${escape(review.review)}</p>` : ''}</div></article>`;
    }
    more.addEventListener('click', async () => {
      if (loading) return;
      loading = true;
      more.disabled = true;
      more.setAttribute('aria-busy', 'true');
      more.textContent = 'LOADING…';
      status.textContent = '';
      try {
        if (!reviews) {
          if (urls.some(url => !url)) throw new Error('Missing review asset');
          const parts = await Promise.all(urls.map(async url => {
            const response = await fetch(url);
            if (!response.ok) throw new Error('Review asset unavailable');
            const part = await response.json();
            if (!Array.isArray(part.reviews)) throw new Error('Invalid review asset');
            return part.reviews;
          }));
          const loaded = parts.flat();
          if (loaded.length !== 212 || loaded.some(review => !review.name || !/^\d{4}-\d{2}-\d{2}$/.test(review.date) || !Number.isInteger(Number(review.rating)) || Number(review.rating) < 1 || Number(review.rating) > 5)) throw new Error('Incomplete review data');
          reviews = loaded;
        }
        const next = reviews.slice(offset, offset + 5);
        list.insertAdjacentHTML('beforeend', next.map(row).join(''));
        offset += next.length;
        status.textContent = `${offset + 5} of 217 reviews shown.`;
        more.textContent = 'LOAD MORE';
        if (offset === reviews.length) {
          status.tabIndex = -1;
          status.focus({preventScroll:true});
          more.hidden = true;
        }
      } catch {
        status.textContent = 'Reviews could not be loaded. Please try again.';
        more.textContent = 'TRY AGAIN';
      } finally {
        loading = false;
        more.disabled = false;
        more.removeAttribute('aria-busy');
      }
    });

    const modal = section.querySelector('[data-review-modal]');
    const open = section.querySelector('[data-open-review]');
    let lastFocus;
    function show() {
      if (modal.open) return;
      lastFocus = document.activeElement;
      modal.showModal();
      document.body.classList.add('yr2-lock');
    }
    open.addEventListener('click', show);
    section.querySelector('[data-close-review]').addEventListener('click', () => modal.close());
    modal.addEventListener('click', event => {
      if (event.target !== modal) return;
      const box = modal.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) modal.close();
    });
    modal.addEventListener('close', () => {
      document.body.classList.remove('yr2-lock');
      if (lastFocus?.isConnected) lastFocus.focus({preventScroll:true});
    });
    const stars = [...modal.querySelectorAll('.yr2__star')];
    modal.addEventListener('change', event => {
      if (event.target.name !== 'contact[Rating]') return;
      stars.forEach(label => label.classList.toggle('is-on', Number(label.querySelector('input').value) <= Number(event.target.value)));
    });
    if (section.querySelector('[data-review-success], [data-review-error]')) show();
  }
  const initializeAll = () => document.querySelectorAll('[data-yr2]').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-review-modal][open]')) document.body.classList.remove('yr2-lock');
  });
})();
